import { messages } from '../i18n/messages';

export interface Label {
  defaultMessage: string;
  id: string;
}

export interface Filter {
  key: string;
  label: Label;
}

export type Filters = Record<string, Label>;

const filters: Filters = {
  sales: messages.filter_sales,
  service: messages.filter_service,
  usedcars: messages.filter_usedcars,
  etron: messages.filter_e_tron,
  'sales-rs': messages.filter_sales_rs,
  'sales-r8': messages.filter_sales_r8,
  'audi-on-demand': messages.filter_audi_on_demand,
  //** Commenting centrum-flotowe since is not ready for production
  // 'centrum-flotowe': messages.filter_centrum_flotowe,
  'accident-specialist': messages.filter_damage_specialist,
  atyourdoor: messages.filter_audi_at_your_door,
  'silver-car-by-audi': messages.filter_silvercar,
  'service-r8': messages.filter_service_r8,
};

export default filters;
